import {FC} from "react";
import styled from "styled-components";
import {useTranslation} from "react-i18next";
import {getLogo} from "modules/utils";

const Wrapper = styled.div`
	display: flex;
	justify-content: center;

	${({theme}) => theme.breakpoints.up("mobile")} {
		padding: 0 20px;
	}
`;

const Img = styled.img`
	width: 161px;

	${({theme}) => theme.breakpoints.up("mobile")} {
		width: 310px;
	}
`;

export const Logo: FC = () => {
	const {i18n} = useTranslation();
	const lang = i18n.language;
	const logo = getLogo(lang);

	return (
		<Wrapper>
			<Img src={logo} alt="CFL Preseasons futures" />
		</Wrapper>
	);
};
